import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
// import 'rxjs/add/operator/map'; // Removed - not needed in RxJS 6+
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
@Injectable({ providedIn: 'root' })
export class RestService {
  public modelName: string = '';
  public headers: HttpHeaders;
  private serverWithApiUrl: string = '';

  // cache data
  public lastGetAll: Array<any> = [];
  public lastGet: any = null;

  constructor(private http: HttpClient) {
    this.modelName = 'to-configure';

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
  }

  public setApiUrl(url: string) {
    this.serverWithApiUrl = url;
  }

  // HELPERS
  public getAllFromLS(maxtime = 0): Array<any> | undefined {
    const json = localStorage.getItem('rest_all_' + this.modelName);
    if(json) {
      const obj = JSON.parse(json);
      if (obj && (obj.date < (Date.now() - maxtime))) {
        return obj;
      }
    }
    return undefined;
  }

  public getFromCache(id: any): any {
    if(this.lastGetAll) {
      return this.lastGetAll.find((unit: any) => unit.id === id);
    } else {
      return null;
    }
  }

  private getActionUrl() {
    return this.serverWithApiUrl + this.modelName + '/';
  }

  // REST functions
  public getAll(): Observable<any[]> {
    return this.http.get<any>(this.getActionUrl(), { headers: this.headers }).pipe(map((response) => {
        // getting an array having the same name as the model
        const data = (response as any)[this.modelName];
        // transforming the array from indexed to associative
        const tab = data.records.map((elem: any) => {
          const unit = {};
          // using the columns order and number to rebuild the object
          data.columns.forEach((champ: any, index: number) => {
            (unit as any)[champ] = elem[index];
          });
          return unit;
        });
        this.lastGetAll = tab;
        const obj = {
          data: tab,
          date: Date.now()
        };
        localStorage.setItem('rest_all_' + this.modelName, JSON.stringify(obj));
        return tab;
      }),
      catchError(this.handleError));
  }

  public get(id: number): Observable<any> {
    return this.http.get(this.getActionUrl() + id, { headers: this.headers }).pipe(map((response) => {
        const data = response;
        this.lastGet = data;
        return data;
      })
      , catchError(this.handleError));
  }

  public add(item: any): Observable<any> {
    const toAdd = JSON.stringify(item);

    return this.http.post<any>(this.getActionUrl(), toAdd, { headers: this.headers }).pipe(map((response) => response),
      catchError(this.handleError));
  }

  public addAll(tab: Array<any>): Observable<any> {
    const toAdd = JSON.stringify(tab);

    return this.http.post<any>(this.getActionUrl(), toAdd, { headers: this.headers }).pipe(map((response) => response),
      catchError(this.handleError));
  }

  public update(id: number, itemToUpdate: any): Observable<any> {
    return this.http.put<any>(this.getActionUrl() + id, JSON.stringify(itemToUpdate), { headers: this.headers }).pipe(map((response) => response),
      catchError(this.handleError));
  }

  public delete(id: number): Observable<any> {
    return this.http.delete(this.getActionUrl() + id, { headers: this.headers }).pipe(
      catchError(this.handleError));
  }

  private handleError(error: any) {
    // console.error(error);
    return throwError(() => error.error || 'Server error');
  }
}
